import React, { useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import { AppContext } from "../AppContext";
import { TextField } from "@material-ui/core";
import { Autocomplete } from '@material-ui/lab';

export default function InvoiceAddressForm(props) {

    const useStyles = makeStyles((theme) => ({
        fullWidth: {
            width: "100%",
            marginBottom: theme.spacing(1)
        },
    }));

    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles();
    const {user, setUser} = props;

    const getCountryObjectByCode = (code) => {
        const country = state.checkout.countries.filter(c => c.code === code)[0];
        return country;
    };

    const isEUCountry = ((countries, code) => {
        return countries.filter(c => (c.eu == 1 && c.code == code)).length > 0;
    });
    

    const handleInvoiceAddressChange = (newValue, key) => {
        setUser({...user, [key]: newValue });
    };

    if (!user || !setUser) {
        return (<p>No user given.</p>)
    }

    return (
        <>
            <TextField className={classes.fullWidth} size="small"
                label={s.invoicePanel.name}
                required
                value={user.name}
                onChange={(e) => handleInvoiceAddressChange(e.target.value, "name")}
            />
            <TextField className={classes.fullWidth} size="small"
                label={s.invoicePanel.companyName}
                value={user.companyName}
                onChange={(e) => handleInvoiceAddressChange(e.target.value, "companyName")}
            />
            <TextField className={classes.fullWidth} size="small"
                label={s.invoicePanel.address1}
                required
                value={user.address1}
                onChange={(e) => handleInvoiceAddressChange(e.target.value, "address1")}
            />
            <TextField className={classes.fullWidth} size="small"
                label={s.invoicePanel.address2}
                value={user.address2}
                onChange={(e) => handleInvoiceAddressChange(e.target.value, "address2")}
            />
            <TextField className={classes.fullWidth} style={{ width: "30%" }} size="small"
                label={s.invoicePanel.zip}
                required
                value={user.zip}
                onChange={(e) => handleInvoiceAddressChange(e.target.value, "zip")}
            />
            <TextField className={classes.fullWidth} style={{ width: "70%", marginRight: 0 }} size="small"
                label={s.invoicePanel.city}
                required
                value={user.city}
                onChange={(e) => handleInvoiceAddressChange(e.target.value, "city")}
            />
            <Autocomplete className={classes.fullWidth}
                options={state.checkout.countries}
                size="small"
                getOptionLabel={(option) => option.name}
                value={getCountryObjectByCode(user.country)}
                onChange={(e, newValue) => handleInvoiceAddressChange(newValue && newValue.code, "country")}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={s.invoicePanel.country}
                        required
                        inputProps={{
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                        }}
                    />
                )}
            />
            {user.companyName && user.country && user.country != "DE" && isEUCountry(state.checkout.countries, user.country) && 
                <TextField style={{ width: "100%" }}
                    size="small"
                    label={s.invoicePanel.vatId}
                    value={user.vatId}
                    onChange={(e) => handleInvoiceAddressChange(e.target.value, "vatId")}
                />}
        </>
    );
}